import React from 'react';
import classes from './Loader.module.scss';
import classNames from 'classnames';
import classesLoader from './Loader.module.scss';
import { Loader } from './index';

type ConditionalOverlayProps =
  | { type?: 'inline'; containedOverlay?: never; roundedBg?: never }
  | { type: 'overlay'; containedOverlay?: boolean; roundedBg?: boolean }
  | { type: 'overlay-transparent'; containedOverlay?: boolean; roundedBg?: never };

export type LoaderViewProps = ConditionalOverlayProps & {
  //
  variation: 'light' | 'dark';
  size: 'small' | 'medium' | 'large';
  type?: 'inline' | 'overlay' | 'overlay-transparent';
};

export const FullPageLoader = (): JSX.Element => {
  return (
    <div className={classesLoader.PageLoaderWrapperFull}>
      <Loader variation={'dark'} size={'large'} />
    </div>
  );
};

export const LoaderView = (props: LoaderViewProps): JSX.Element => {
  const loaderWrapperClasses = classNames(
    props.size === 'small' ? [classes.LoaderWrapperSmall] : [classes.LoaderWrapperLarge],
    classes.LoaderWrapper
  );

  const loaderOverlayClasses = classNames(
    [classes.LoaderOverlay],
    props.variation === 'dark' ? [classes.LoaderOverlayDark] : [classes.LoaderOverlayLight],
    {
      [classes.LoaderOverlayRoundedOverlay]: !!props.containedOverlay && props.roundedBg
    },
    { [classes.LoaderOverlayTransparent]: props.type === 'overlay-transparent' }
  );

  const spinnerClasses = classNames(
    classes.Spinner,
    props.size === 'small'
      ? [classes.SpinnerSmall]
      : props.size === 'medium'
      ? [classes.SpinnerMedium]
      : [classes.SpinnerLarge],
    props.variation === 'light' ? [classes.SpinnerLight] : [classes.SpinnerDark]
  );

  const preloaderElem = (
    <div className={loaderWrapperClasses}>
      <div className={spinnerClasses}>
        <span className={'show-for-sr'}>Loading...</span>
      </div>
    </div>
  );

  const buffer =
    props?.type === 'overlay' || props?.type === 'overlay-transparent' ? (
      <div className={loaderOverlayClasses}>{preloaderElem}</div>
    ) : (
      preloaderElem
    );

  return (props?.type === 'overlay' || props?.type === 'overlay-transparent') && !!props.containedOverlay ? (
    <div className={classes.OverlayWrapper}>{buffer}</div>
  ) : (
    buffer
  );
};
